function getCookie(c_name) {
  var c_value = document.cookie,
    c_start = c_value.indexOf(" " + c_name + "=");
  if (c_start == -1) c_start = c_value.indexOf(c_name + "=");
  if (c_start == -1) {
    c_value = null;
  } else {
    c_start = c_value.indexOf("=", c_start) + 1;
    var c_end = c_value.indexOf(";", c_start);
    if (c_end == -1) {
      c_end = c_value.length;
    }
    c_value = unescape(c_value.substring(c_start, c_end));
  }
  return c_value;
}

$(document).ready(function () {
  function checkCookie() {
    // Code to run when the document is ready.
    console.log("checking cookie");

    /* look for the cookiebar cookie */
    var acookie = getCookie("cookieconsent_status");
    if (!acookie) {
      /* cookie not found */
      $("#dixa-iframe-wrapper").hide();
      console.log("cookie not found");
    } else {
      /* cookie found */
      $("#dixa-iframe-wrapper").show();
      console.log("cookie found");
    }
  }

  setTimeout(
    checkCookie,
    2000
  ); /* needs a delay to wait for the help to load */

  $(".cc-window.cc-banner").change(function () {
    console.log("cookie cliked");
  });

  if ($(".cc-window.cc-banner:visible").length == 0) {
    console.log("cookie pop is on page");

    $(this).on("change", ".cc-window.cc-banner", function (e) {
      console.log("cookie cliked");
    });
  } else {
    console.log("cookie pop is hidden");
  }

  /* select item */ $(
    ".lightning_product-page--main-content .pw-option-selector"
  ).change(function () {
    var selectedItem = $(this).children("option:selected").val();
    console.log("Item Selected " + selectedItem);
    $("#rc_radio_options .rc_block__type--active").trigger("click");
  });

  /* pw+ step */
  $(".signup-step-one a.alreadymember").click(function () {
    console.log("clicked");
    $(".create-customer-step").hide();
    $(".customer-login-step").show();

    $(".already-member").hide();
    $(".signing-up").show();
  });

  $(".signup-step-one a.signingup").click(function () {
    console.log("clicked");
    $(".create-customer-step").show();
    $(".customer-login-step").hide();

    $(".already-member").show();
    $(".signing-up").hide();
  });




  $('.lp-section22 .pause').on('click', function() {
    $('.item-slider-one, .item-slider-two')
        .slick('slickPause')
});

$('.lp-section22 .play').on('click', function() {
  $('.item-slider-one, .item-slider-two')
        .slick('slickPlay')
});




  // close jQuery
});

function initLandingPageSliders() {
  /* slick for PW+ */

  $(".item-slider-one").slick({
    dots: false,
    arrows: false,
    // infinite: true,
    // centerMode: true,
    // centerPadding: '20px',
    // easing: 'linear',
    //   initialSlide: '6',
    // lazyLoad: 'ondemand',
    // edgeFriction: '0.15',
    speed: 9000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    rtl: false,
  });

  $(".item-slider-two").slick({
    dots: false,
    arrows: false,
    // infinite: true,
    // centerMode: true,
    // centerPadding: '20px',
    // easing: 'linear',
    //   initialSlide: '6',
    // lazyLoad: 'ondemand',
    // edgeFriction: '0.15',
    speed: 6000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    rtl: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
}

$(window).load(function () {
  /* cc-window cc-banner  */

  $("#ba-cookie-dismiss").on("click", function () {
    $("#dixa-iframe-wrapper").show();
    console.log("cookie cliked");
  });
});
